import * as React from 'react';

import { InfoMessage, InfoMessageTypeEnum } from '@websky/graphql';
import { EngineTheme, ThemeProvider } from '../../theme';
import { ButtonVariant } from '../../BaseComponents/Button/types';
import BaseNotification, { Props as BaseProps } from '../../BaseComponents/Notification';

const STATUS_MAP: Record<InfoMessageTypeEnum, BaseProps['status']> = {
	[InfoMessageTypeEnum.Warning]: 'error',
	[InfoMessageTypeEnum.Promo]: 'note',
	[InfoMessageTypeEnum.Info]: 'warning',
	[InfoMessageTypeEnum.SubscriptionSaving]: 'subscription',
	[InfoMessageTypeEnum.HtmlContent]: 'note'
};

export interface Props {
	className?: string;
	iconClassName?: string;
	contentClassName?: string;
	titleClassName?: string;
	textClassName?: string;
	contextClassName?: string;
	globalClassName?: string;
	htmlClassName?: string;
	title?: string;
	image?: string;
	icon?: React.ReactNode;
	status: InfoMessageTypeEnum;
	type: 'global' | 'context';
	infoMessage: InfoMessage;
	actionClassName?: string;
	actionText?: string;
	actionVariant?: ButtonVariant;
	actionLoading?: boolean;
	onClickAction?: () => void;
	renderMessagesWithoutWrapper?: boolean;
	hideIcon?: boolean;
}

/**
 * @deprecated - use BaseComponents/Notification
 */
const Notification: React.FC<Props> = ({
	className,
	iconClassName,
	contentClassName,
	titleClassName,
	textClassName,
	contextClassName,
	globalClassName,
	htmlClassName,
	title,
	image,
	icon,
	status,
	type,
	infoMessage,
	actionClassName,
	actionText,
	actionVariant = 'optionEdit',
	onClickAction,
	actionLoading,
	renderMessagesWithoutWrapper,
	hideIcon
}) => {
	if (renderMessagesWithoutWrapper) {
		return <div className={htmlClassName} dangerouslySetInnerHTML={{ __html: infoMessage.text }} />;
	}

	const classNames: EngineTheme = React.useMemo(() => {
		return {
			BaseComponents: {
				Notification: {
					icon: iconClassName,
					content: contentClassName,
					title: titleClassName,
					text: textClassName,
					context: contextClassName,
					global: globalClassName,
					action: actionClassName
				}
			}
		};
	}, [
		iconClassName,
		contentClassName,
		titleClassName,
		textClassName,
		contextClassName,
		globalClassName,
		actionClassName
	]);

	return (
		<ThemeProvider value={classNames}>
			<BaseNotification
				type={type}
				className={className}
				code={infoMessage.code}
				title={title ?? infoMessage.title}
				icon={icon}
				actionText={actionText}
				actionLoading={actionLoading}
				onClickAction={onClickAction}
				image={image}
				text={infoMessage.text}
				actionVariant={actionVariant}
				hideIcon={hideIcon}
				asHtml={infoMessage.type === InfoMessageTypeEnum.HtmlContent}
				status={STATUS_MAP[status ?? infoMessage.type] ?? 'done'}
			/>
		</ThemeProvider>
	);
};

export default Notification;
